module.exports = __webpack_public_path__ + "static/media/recipe_userOnly_image_right_pc.5c5a89b0.png";